import React, { Suspense } from "react";
// swiper bundle styles
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "App.css";
// swiper core styles

import { BrowserRouter as Router, Switch } from "react-router-dom";

import AppRoute from "./Route/AppRoute";
import routes from "./Route/Routes";

function App() {
  return (
    <Suspense fallback="...loading">
      <Router>
        <Switch>
          {routes.map((route) => (
            <AppRoute
              key={route.path}
              path={route.path}
              component={route.component}
              isPrivate={route.isPrivate}
              exact={route.exact}
            />
          ))}
        </Switch>
      </Router>
    </Suspense>
  );
}

export default App;
